var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSecurepack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 24h-13A2.502 2.502 0 013 21.5v-19C3 1.121 4.121 0 5.5 0h13C19.879 0 21 1.121 21 2.5v19c0 1.379-1.121 2.5-2.5 2.5zM5.5 1C4.673 1 4 1.673 4 2.5v19c0 .827.673 1.5 1.5 1.5h13c.827 0 1.5-.673 1.5-1.5v-19c0-.827-.673-1.5-1.5-1.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4 6H7.6a2.495 2.495 0 01-2.112-1.161l-2.05-3.221a.5.5 0 01.844-.537l2.05 3.221C6.61 4.739 7.085 5 7.6 5h8.8a1.5 1.5 0 001.268-.698l2.05-3.221a.5.5 0 11.843.537l-2.05 3.221A2.492 2.492 0 0116.4 6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10.5a.5.5 0 01-.5-.5V5.5a.5.5 0 011 0V10a.5.5 0 01-.5.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.5c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zm0-3a1 1 0 100 2 1 1 0 000-2z"
  })));
}

export default SvgSecurepack;